import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import urlJoin from 'url-join';
import { Button } from '@clearcover/atlas';
import { Modal } from 'Shared/components';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

type DiscoveredDriversModalPropsType = {
  open: boolean;
};

export const DiscoveredDriversModal: FC<DiscoveredDriversModalPropsType> = ({
  open,
}) => {
  const { appId } = useAppContext();
  const history = useHistory();

  const navigateToSummary = useCallback(() => {
    history.push(urlJoin(QUOTE_APP_ROUTE, appId, 'summary'));
  }, [appId, history]);

  return (
    <Modal showModal={open} disableCurtainClick>
      <div className={styles.modalContainer}>
        <h4 className={styles.header}>Additional Driver Details Needed</h4>
        <p className={styles.content}>
          We've found additional drivers in vehicle and driver reports. These
          have been added to the policy. Please click "Complete Driver Details"
          to navigate back to the Summary page to enter details about the
          additional drivers.
        </p>
        <div className={styles.footer}>
          <Button
            data-testid="discovered-drivers-modal-button"
            className={styles.button}
            variant="primary"
            onClick={navigateToSummary}
          >
            Complete Driver Details
          </Button>
        </div>
      </div>
    </Modal>
  );
};
